.rea-page {
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  header,
  footer {
    display: flex;
    flex: 0 1 auto;
    flex-grow: 0;
    flex-shrink: 0;
  }

  main {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1 1 auto;
    width: 100%;
    margin: 0 auto;

    @media screen and (width >= 1088px) {
      max-width: 960px;
    }

    @media screen and (width >= 1280px) {
      max-width: 1152px;
    }

    @media screen and (width >= 1472px) {
      max-width: 1344px;
    }

    & > * {
      overflow: auto;
      height: 100%;
    }
  }
}
